export const gatewayPath = '/do-federated-gateway/v1/graphql'
export const baseAuthUrl =
  window.TT_GLOBALS?.bookingApiUrl ===
  'https://ws-preprod.eng.toasttab.com/booking/'
    ? 'https://ws-preprod-api.eng.toasttab.com'
    : 'https://ws-api.toasttab.com'
